/**
 * Página de Login — App Saúde
 * Design profissional — App Saúde
 */

import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LoginForm } from '@/components/auth';
import { ThemeToggle } from '@/components/common';
import { BrandMark } from '@/components/common/BrandMark';

export default function LoginPage() {
  return (
    <div className="min-h-screen w-full flex bg-white dark:bg-neutral-950">
      {/* Theme toggle */}
      <div className="fixed top-4 right-4 z-50">
        <ThemeToggle />
      </div>

      {/* Left side - Doctor image fullscreen */}
      <div className="hidden md:flex md:w-1/2 relative overflow-hidden">
        <img
          src="/images/capa.jpeg"
          alt="App Saúde"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/20" />
      </div>

      {/* Right side - Form section */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 md:p-12 bg-white dark:bg-neutral-950 overflow-y-auto">
        <div className="w-full max-w-md flex flex-col items-center">
          <Link
            to="/"
            className="mb-4 inline-flex items-center gap-1.5 self-start text-sm text-gray-500 transition-colors hover:text-teal-700 dark:text-gray-400 dark:hover:text-teal-400"
          >
            <ArrowLeft className="size-3.5" aria-hidden />
            Voltar ao início
          </Link>

          {/* Logo Centralizada e destacada */}
          <div className="flex flex-col items-center justify-center mb-4">
            <BrandMark
              size="2xl"
              className="justify-center"
              imageClassName="h-44 w-44 md:h-56 md:w-56"
            />
          </div>

          {/* Heading */}
          <div className="text-center mb-6 space-y-1.5 w-full">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white tracking-tight">
              Bem-vindo ao App Saúde
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm md:text-base">
              Telemedicina e atendimento domiciliar integrados
            </p>
          </div>

          {/* Form */}
          <div className="w-full">
            <LoginForm />
          </div>

          {/* Footer */}
          <div className="mt-8 text-center text-xs text-gray-500 dark:text-gray-400">
            <p>
              © {new Date().getFullYear()} App Saúde. |{' '}
              <Link to="/privacy" className="text-teal-600 hover:text-teal-700 dark:text-teal-400 dark:hover:text-teal-300">
                Privacidade
              </Link>
              {' '} |{' '}
              <Link to="/terms" className="text-teal-600 hover:text-teal-700 dark:text-teal-400 dark:hover:text-teal-300">
                Termos
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
